import React from 'react';

import { FilterTwoTone } from '@ant-design/icons';
import { Button, CheckboxOptionType, Dropdown, theme } from 'antd';

import { Filters } from '../../interfaces';

import { CheckboxGroup } from './styles';

interface IProps {
  selectedFilters: Filters[];
  filters: CheckboxOptionType[];
  onChange: (filters: Filters[]) => void;
}

export const FilterEditMenu: React.FC<IProps> = ({ selectedFilters, filters, onChange }) => {
  const { token } = theme.useToken();

  return (
    <Dropdown
      trigger={['click']}
      placement="bottomRight"
      popupRender={() => (
        <div
          style={{
            backgroundColor: token.colorBgElevated,
            borderRadius: token.borderRadiusLG,
            boxShadow: token.boxShadowSecondary,
          }}>
          <CheckboxGroup onChange={(opt) => onChange(opt as Filters[])} options={filters} value={selectedFilters} />
        </div>
      )}>
      <Button
        onClick={(e) => e.preventDefault()}
        icon={<FilterTwoTone twoToneColor={token.colorPrimary} />}
        size="middle"
      />
    </Dropdown>
  );
};
